import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { FormsModule, ReactiveFormsModule }   from '@angular/forms';
import { NgForm } from '@angular/forms';
import { AuthService } from '../../services/authentication/auth.service';
import { PersonnelService } from '../../services/personnel/personnel.service';
import { PersonnelDetail } from '../../services/personnel/personnel-detail';
import { AlertService } from '../../services/alert.service';
import { ViewBaseComponent } from '../../views/view-base.component';

@Component({
  templateUrl: 'signaletique-detail.component.html'
})
export class SignaletiqueDetailComponent extends ViewBaseComponent implements OnInit {

  personnel: PersonnelDetail = new PersonnelDetail();
  isEditing = false;

  constructor(
    protected authService: AuthService,
    protected alertService: AlertService,
    private router: Router,
    private route: ActivatedRoute,
    private personnelService: PersonnelService) {
    super(authService, alertService);
  }

  ngOnInit() {
    this.personnelService.getPersonnelByCle(this.route.snapshot.params.cle).subscribe(
      personnel => {
        this.personnel = personnel;
      }
    );
  }

}
